export default __webpack_public_path__ + "static/media/Opus Adnullatus.b690562e.jpg";